// extracted by mini-css-extract-plugin
export default {"root":"Portal_root__2g1Bt"};